import { render } from "./MemberManagementPage.vue?vue&type=template&id=2f9cd37e"
import script from "./MemberManagementPage.vue?vue&type=script&lang=js"
export * from "./MemberManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__